import { useQuery } from '@apollo/client';
import { UserEstatesQueryActions, GetUserEstatesT, EstatePublication, GET_USER_ESTATES } from '@contexts/Estate';
import { ResponseApolloErrorMapping } from '@shared/data-mappers';
import { UserEstatesDto } from '../dtos';

export const GqlUserEstatesQueryActions: UserEstatesQueryActions = {
  useGetUserEstates: (): GetUserEstatesT => {
    const { data, loading, error, refetch } = useQuery<UserEstatesDto>(GET_USER_ESTATES, {
      errorPolicy: 'all',
    });

    const mapRecalling = (): Promise<Array<EstatePublication> | undefined> =>
      (refetch && refetch().then((response) => response.data?.getUserEstates)) || Promise.resolve(undefined);

    return {
      loading,
      recall: mapRecalling,
      error: error && ResponseApolloErrorMapping(error),
      estates: data?.getUserEstates,
    };
  },
};
